import styled from 'styled-components';
import { themeGet } from 'styled-system';

const FeatureSectionWrapper = styled.section`
  padding: 80px 0;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 60px 0 30px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0 30px 0;
  }
  .subtitle {
    max-width: 817px;
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
  }
  .feature__block {
    position: relative;
    height: 100%;
    transition: box-shadow 0.3s ease;
    .icon__wrapper {
      position: relative;
     
      .flaticon-flask {
        &:before {
          margin-left: 8px;
        }
      }
    }
    &:hover {
      box-shadow: 0 40px 90px -30px rgba(39, 79, 117, 0.2);
    }
  }
  .row {
    display: flex;
    justify-content: center;
    > .col {
      &:nth-child(-n + 3) {
        border-top: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
      }
      &:nth-child(3n + 3),
      &:last-child {
        border-right: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
      }
      @media only screen and (max-width: 991px) {
        &:nth-child(-n + 3) {
          border-top: 0;
        }
        &:nth-child(3n + 3) {
          border-right: 0;
        }
        &:nth-child(-n + 2) {
          border-top: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
        }
        &:nth-child(2n + 2) {
          border-right: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
        }
      }
      @media only screen and (max-width: 480px) {
        &:nth-child(-n + 2) {
          border-top: 0;
        }
        &:nth-child(2n + 2) {
          border-right: 0;
        }
        &:nth-child(-n + 1) {
          border-top: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
        }
        &:nth-child(1n + 1) {
          border-right: 1px solid ${themeGet('colors.lightBorder', '#f1f4f6')};
        }
      }
    }
  }
`;

export default FeatureSectionWrapper;
